import { paymentMethodLabel } from '../../services/salesApi';

// Estado de una venta en persona -> etiqueta y color de StatusBadge.
//   confirmed (sin usar) -> completed (entró) · cancelled (anulada, paymentStatus voided)
export const saleStatus = (sale) => {
  if (sale.status === 'cancelled' || sale.paymentStatus === 'voided') {
    return { status: 'cancelled', label: 'Anulada' };
  }
  if (sale.status === 'completed') return { status: 'completed', label: 'Entró' };
  return { status: 'confirmed', label: 'Sin usar' };
};

export const isVoided = (sale) => saleStatus(sale).status === 'cancelled';

export { paymentMethodLabel };
